import AudioPlayer from './AudioPlayer';
import { default as Slider } from './Rangeable';

const formatTime = (timestamp) => { // timestamp is represented in seconds
  const
    seconds = Math.trunc((timestamp) % 60),
    minutes = Math.trunc((timestamp / 60) % 60),
    hours = Math.trunc((timestamp / (60 * 60)) % 24),

    formatHours = (hours) ? hours.toString() + ":" : "",
    formatMinutes = (minutes) ? minutes.toString() + ":" : "00:",
    formatSeconds = (seconds) ? seconds.toString().padStart(2, "0") : "00";

  return formatHours + formatMinutes + formatSeconds;
}

const formatObjectKeys = (object) => {
  return Object.keys(object)
    .sort() // object keys are typically ordered, but may not be, especially when converting between JSON
    .map(key => ({ key, value: object[key] }));
}

const parseTime = (timestamp) => {
  // validate "00", "00:00", "00:00:00" format
  if (typeof timestamp !== 'string'
    || timestamp.split(':').length === 0
    || timestamp.split(':').length > 3
  ) return null;

  return timestamp.split(':').reverse()
    .reduce((total, region, index) => {
      // ignore empty sections caused by leading colons ":56" 
      if (region.trim() === '') return total;
      return total + (parseInt(region, 10) * (60 ** index))
    }, 0);
};

const query = (selector)=> {
  const nodes = document.querySelectorAll(selector);
  return (nodes.length > 1) ? nodes : nodes[0];
}

const queryEach = (selector, callback) => {
  const nodes = document.querySelectorAll(selector);
  nodes.forEach(callback);
}


class VideoPlayer {
  constructor(videoSettings) {

    // build out audio player
    const audioSettings = {
      errorMode: false,
      timeout: 3000,
      sources: videoSettings.sources,
    }
    this.instance = new AudioPlayer(audioSettings);
    this.videoSettings = videoSettings;

    // touch events fire twice.
    this.canClick = true;
    this.disableClick = () => {
      this.canClick = false;
      setTimeout(()=> this.canClick = true, 100)
    }

    this.handleIOSEdgeCases();
    this.syncSliderEvents();
    this.syncPlayerControls();
    this.syncSubtitlesAndPhotos();
    this.autoPlay();
    this.initializeModalEvents();
    this.syncLocalStorage();
  }


  closeModals() {
    if (countdown) clearInterval(countdown);

    queryEach('.video-modal', modal => {
      modal.classList.add('is-hidden');
      modal.setAttribute('aria-hidden', 'true');
      modal.setAttribute('aria-modal', 'false');
    });
    // reinstate the Share button if missing
    query('.header_share').classList.remove('is-hidden');
  }
  launchModal(modal) {
    modal.classList.remove('is-hidden');
    modal.setAttribute('aria-hidden', 'false');
    modal.setAttribute('aria-modal', 'true');
  }



  handleIOSEdgeCases () {
    if (!isIOS) return;

    // set appropriate player state
    this.instance.state.playing = false;

    // display iOS specific features
    queryEach('.is-ios', el => el.style.display = 'flex');

    // connect the one-time play button
    queryEach('.is-ios.play_initiator', button => {
      button.addEventListener('click', event => {
        // play button plays audio
        const { audio } = this.instance;
        audio.pause();
        audio.play()
          .then(() => {
            // hide button after first click
            const button = event.target.closest('.play_initiator');
            button.style.display = 'none';
          })
      })
    });

    const controls = query('#overlay-controls');
    let canOpen = true;
    let controlsTimeout;

    // copy of normal events
    const setControlsInactive = () => {
      controls.classList.add('is-hidden');
      controls.setAttribute('aria-hidden', 'true');
      controls.setAttribute('aria-modal', 'false');
    }

    const setOverlayActive = (event) => {
      if (!this.canClick) return;
      this.launchModal(controls);
      this.disableClick();

      if (controlsTimeout) clearTimeout(controlsTimeout);
      controlsTimeout = setTimeout(() => {
        setControlsInactive();
        // enable click shortly after
        canOpen = false;
        setTimeout(()=> canOpen = true, 500);
      }, 5000); 
    };


    // build events for iOS
    window.addEventListener('touchstart', event => {
      const { target } = event;
      const isOverPhoto = target.closest('.photo-overlay');
      const isOverModal = target.closest('.video-modal');

      if (isOverPhoto || isOverModal) {
        if (!canOpen) return;
        setOverlayActive();
        canOpen = false;
      }
      else {
        this.closeModals();
        canOpen = true;
      }
    })
  }




  initializeModalEvents() {
    const player = this.instance;
    // Create controls to close modals

    /// close modals when user presses countdown X
    queryEach('.vm_countdown_close', close => {
      close.addEventListener('click', ()=> {
        this.closeModals();
      })
    });

    /// close modals when user presses ESC
    window.addEventListener('keydown', (event) => {
      const currentKey = event.key;
      if (currentKey === 'Escape') {
        this.closeModals();
      }
    });


    if (!isIOS) {

    // set behavior for controls modal
    const controls = query('#overlay-controls');
    let canOpen = true;
    let controlsTimeout;
    // when user presses the ESC key while hovering over the controls,
    // they should not immediately re-appear
    // canOpen tracks whether the modal is in an open-able state

    // Close only the controls overlay
    ///  this function will be the callback for a timeout
    const setControlsInactive = () => {
      controls.classList.add('is-hidden');
      controls.setAttribute('aria-hidden', 'true');
      controls.setAttribute('aria-modal', 'false');
    }

    const setOverlayActive = (event) => {
      if (!this.canClick) return;
      this.launchModal(controls);
      this.disableClick();

      if (controlsTimeout) clearTimeout(controlsTimeout);
      controlsTimeout = setTimeout(() => {
        setControlsInactive();
        // enable click shortly after
        canOpen = false;
        setTimeout(()=> canOpen = true, 500);
      }, 5000); 
    };

    /// close modals when user clicks away
    window.addEventListener('click', (event) => {
      const { target } = event;
      const currentModal = target.closest('.video-modal');
      const currentPhoto = target.closest('.photo-overlay');

      // close modal if user clicks outside of it
      if (currentModal) console.log('click:: target is modal');
      else if (currentPhoto) console.log('click:: target is photo');
      else {
        this.closeModals();
      }
    });
    queryEach('.photo-overlay, .video-modal', el => el.setAttribute('onclick', ''));

    window.addEventListener('mouseover', (event)=> {
      const { target } = event;
      const isOverPhoto = target.closest('.photo-overlay');
      const isOverModal = target.closest('.video-modal');

      if (isOverPhoto) {
        if (!canOpen) return;
        setOverlayActive();
        canOpen = false;
      }
      else if (isOverModal) console.log('mouseover:: target is modal');
      // plain and simple
      // you cannot open the controls again until you've moved
      // outside of the controls area
      if (!isOverPhoto && !isOverModal) canOpen = true;
    })

    }  // end isIOS


    // Launch NEXT modal when user reaches the end
    player.sync('playerend', 'launchNextModal', (instance) => {
      const nextOverlays = '#overlay-next-portrait, #overlay-next-landscape';
      const shareOverlay = query('#share-modal');

      const initiateNextModal = () => {
        const timers = '.vm_countdown_timer';
        // set initial time
        let secondsRemaining = 5;
        queryEach(timers, timer => timer.innerText = formatTime(secondsRemaining));

        // launch the modal
        this.closeModals();
        queryEach(nextOverlays, this.launchModal);

        // start the countdown
        countdown = setInterval(()=> {
          // once countdown is over, trigger a redirect
          if (secondsRemaining === 0) {
            clearInterval(countdown);
            window.location.href = nextURL;
          }
          queryEach(timers, timer => timer.innerText = formatTime(secondsRemaining));
          secondsRemaining--;
        }, 1000);
      }

      const isHidden = element => (
        window.getComputedStyle(element).display === 'none'
      )

      // do not launch next modal if share is visible
      if (isHidden(shareOverlay)) {
        initiateNextModal();
      }
    });
  }

  autoPlay() {
    const player = this.instance;
    const settings = this.videoSettings;
    player.sync('playerready', 'autoPlay', (instance) => {
      if (settings.autoplay === true) instance.audio.play();
    });
  }


  syncPlayerControls() {
    const player = this.instance;

    // Prevent accidental link clicks
    queryEach('.video-modal a', link => {
      link.addEventListener('click', event => {
        if (!this.canClick) event.preventDefault();
      })
    })

    // Sync Time Labels
    const startTime = document.querySelectorAll('[data-hook="time-current"]');
    const endTime = document.querySelectorAll('[data-hook="time-duration"]');

    startTime.forEach(time => time.innerHTML = formatTime(0));
    endTime.forEach(time => time.innerHTML = formatTime(0));

    player.sync('playerready', 'initializeTimes', (instance) => {
      endTime.forEach(time => time.innerHTML = formatTime(instance.audio.duration));
    });

    player.sync('timeupdate', 'updateTimeLabels', (instance) => {
      startTime.forEach(time => time.innerHTML = formatTime(instance.audio.currentTime));
    });


    // Sync Play/Pause button
    queryEach('.vm_control_play-pause', (button) => {
      button.addEventListener('click', event => {
        if (!this.canClick) return;
        const { playing } = player.state;

        if (playing) player.pause();
        else player.play();
      })
    });
    // sync play/pause visuals separate from the button logic
    ///  this decreases the chance that the toggled icon gets out of sync
    player.sync('play', 'setPlayState', (instance) => {
      ///  set pause button once we start playing
      queryEach('.vm_control_play', btn => btn.classList.add('is-hidden'));
      queryEach('.vm_control_pause', btn => btn.classList.remove('is-hidden'));
    });
    player.sync('pause', 'setPauseState', (instance) => {
      ///  set play button once we pause
      queryEach('.vm_control_play', btn => btn.classList.remove('is-hidden'));
      queryEach('.vm_control_pause', btn => btn.classList.add('is-hidden'));
    });


    // Sync Volume button
      queryEach('.vm_control_volume', (button) => {
        button.addEventListener('click', event => {
          if (!this.canClick) return;
          const { volume } = player.audio;

          if (volume > 0) player.mute();
          else player.unmute();
        })
      })
    // again, separate the visuals from the logic
    ///  these are more resistant to external errors
    player.sync('volumechange', 'setVolumeIcon', (instance) => {
      const { volume } = instance.audio;

      if (volume > 0) {
        queryEach('.vm_control_sound', btn => btn.classList.remove('is-hidden'));
        queryEach('.vm_control_sound-off', btn => btn.classList.add('is-hidden'));
      } else {
        queryEach('.vm_control_sound', btn => btn.classList.add('is-hidden'));
        queryEach('.vm_control_sound-off', btn => btn.classList.remove('is-hidden'));
      }
    });
  }


  syncLocalStorage() {
    const player = this.instance;
    let continueFiring = true;

    player.sync('timeupdate', 'syncLocalStorage', (instance) => {
      if (continueFiring === false) return;

      const { currentTime } = instance.audio;
      if (currentTime >= 10) {
        const storage = getFYAFStorage();
        // if episodes_watched doesn't exist, create it
        if (!storage['episodes_watched']) storage['episodes_watched'] = [];

        // if episode has already been watched, don't mark it again
        if (!storage['episodes_watched'].includes(data.key)) {
          storage['episodes_watched'].push(data.key);
        }
        setFYAFStorage(storage);

        // we only need to successfully see the video once
        continueFiring = false;
      }
    })
  }


  syncSubtitlesAndPhotos(event) {
    const player = this.instance;

    const { speakers, subtitles } = this.videoSettings;

    const processTimestampList = (list) => {
      // formatObjectKeys:
      ///  turns   "0:00" : "A few years before..."
      ///  into    { key: "0:00", value: "A few years before..." }
      ///  this can be useful when keys are a sorting condition
      return formatObjectKeys(list)
        .map(line => {
          line.key = parseTime(line.key);
          return line;
        }) 
        .sort((a, b) => a.key - b.key)
        .reverse();
    };
    const tidySpeakers = processTimestampList(speakers);
    const tidySubtitles = processTimestampList(subtitles);

    let lastSpeakerTime = 0;
    player.sync('timeupdate', 'syncSpeakers', (instance) => {
      const { currentTime } = instance.audio;
      const nextSpeaker = tidySpeakers
        .find(speaker => speaker.key <= currentTime);

      const thisSpeakerTime = nextSpeaker && nextSpeaker.key;
      if (thisSpeakerTime === lastSpeakerTime) return;

      const speaker = nextSpeaker.value;
      queryEach('.speaker_name', el => el.innerText = speaker.name);
      queryEach('.speaker-title', el => el.innerText = speaker.title);

      formatImage(responsiveImages[0], speaker.photoFull);
      formatImage(responsiveImages[1], speaker.photoCrop);

      lastSpeakerTime = thisSpeakerTime;
    });

    let lastSubtitleTime = 0;
    player.sync('timeupdate', 'syncSubtitles', (instance) => {
      const { currentTime } = instance.audio;
      const nextSubtitle = tidySubtitles
        .find(subtitle => subtitle.key <= currentTime);

      const thisSubtitleTime = nextSubtitle && nextSubtitle.key;
      if (thisSubtitleTime === lastSubtitleTime) return;

      if (thisSubtitleTime) {
        queryEach('.content_subtitles', el => el.innerHTML = nextSubtitle.value);
        lastSubtitleTime = thisSubtitleTime;
      }
    });
  }



  syncSliderEvents() {
    const player = this.instance;

    const sliderPortrait = new Slider("[data-hook='slider-portrait']", { value: 0 });
    const sliderLandscape = new Slider("[data-hook='slider-landscape']", { value: 0 });
    const sliders = [sliderPortrait, sliderLandscape];

    // steps affects the smoothness of the slider
    // this is the number of steps in the slider per second
    const steps = 1000;

    const initializeSliders = (instance, _event) => {
      const { duration } = instance.audio;

      sliders.forEach(slider => {
        // adjust the slider based on the duration;
        slider.input.max = Math.trunc(duration * steps);

        // update the audio time when the slider is changed
        slider.input.addEventListener("change", () => {
          const newTime = Number(slider.input.value) / steps;
          instance.audio.currentTime = newTime;
        });
      });
    };

    const synchronizeProgressBars = (instance, _event) => {
      const { currentTime } = instance.audio;

      // check if either slider is active
      // if so, ignore the default time updating
      const pins = document.querySelectorAll('.ranger-handle');
      const isActive = [...pins].some(pin => pin.classList.contains('active'));
      if (isActive) return;

      const value = Math.trunc(currentTime * steps);
      sliders.forEach((slider) => {
        slider.input.value = value;
        slider.update();
      });
    };

    player.sync('playerready', 'initializeSliders', initializeSliders);
    player.sync('timeupdate', 'synchronizeProgressBars', synchronizeProgressBars);


    // Update time from Slider
    const startTime = document.querySelectorAll('[data-hook="time-current"]');

    sliders.forEach(slider => {
      slider.input.addEventListener('input', () => {
        const newTime = slider.input.value / steps;
        startTime.forEach(time => time.innerHTML = formatTime(newTime));
      });
    })
  }
}

export default VideoPlayer;